import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=2b1c162d"
import script from "./Memory.vue?vue&type=script&lang=js"
export * from "./Memory.vue?vue&type=script&lang=js"
import style0 from "./Memory.vue?vue&type=style&index=0&id=2b1c162d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports